import { addNotify } from 'features/notify';
import { getErrorMessage } from 'shared/helpers/getErrorMessage';

const actionTypes = {
  ACTION_PROCESSING: 'assistant/ACTION_PROCESSING',
  IS_OPENED: 'assistant/IS_OPENED',
  TABLE_INFO: 'assistant/TABLE_INFO',
  TABLE_CLEAR: 'assistant/TABLE_CLEAR',
  PARSED_MESSAGE: 'assistant/PARSED_MESSAGE',
};
const setActionProcessing = actionProcessing => async dispatch => {
  dispatch({
    type: actionTypes.ACTION_PROCESSING,
    payload: {
      [actionTypes.ACTION_PROCESSING]: actionProcessing,
    },
  });
};

const handleAssistantModal = isOpened => async dispatch => {
  dispatch({
    type: actionTypes.IS_OPENED,
    payload: {
      [actionTypes.IS_OPENED]: isOpened,
    },
  });
};

const clearTableData = () => async dispatch => {
  dispatch({
    type: actionTypes.TABLE_CLEAR,
  });
};

const setParsedMessage = message => async dispatch => {
  dispatch({
    type: actionTypes.PARSED_MESSAGE,
    payload: {
      [actionTypes.PARSED_MESSAGE]: message,
    },
  });
};

const getTableData = data => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;
  dispatch(setActionProcessing(true));

  const response = await api.assistant.getTableData(data);
  const errorMessage = getErrorMessage(locale, response);

  if (response.success) {
    dispatch({
      type: actionTypes.TABLE_INFO,
      payload: {
        [actionTypes.TABLE_INFO]: response.data,
      },
    });
  } else {
    dispatch(addNotify(errorMessage, 'error'));
  }
  dispatch(setActionProcessing(false));
};

const parseText = text => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;
  dispatch(setActionProcessing(true));

  const response = await api.assistant.parseText(text);

  if (!response.success) {
    dispatch(addNotify(getErrorMessage(locale, response), 'error'));
    dispatch(setActionProcessing(false));
    return null;
  }

  const parsed = response.data?.[0] ?? null;
  dispatch(setParsedMessage(parsed?.text_template ?? ''));
  dispatch(setActionProcessing(false));
  return parsed;
};

export {
  actionTypes,
  getTableData,
  clearTableData,
  handleAssistantModal,
  parseText,
  setParsedMessage,
};
